import { IconProps } from "types/StylesTypes";

export const InstrumentListsIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="6" r="1.5" stroke="currentColor" strokeWidth="2" />
      <path
        d="M9 6H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="5" cy="12" r="1.5" stroke="currentColor" strokeWidth="2" />
      <path
        d="M9 12H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="5" cy="18" r="1.5" stroke="currentColor" strokeWidth="2" />
      <path
        d="M9 18H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
